import {config} from "../../../../../config";

/**
 * Installe notre propre suivi sur nos propres sites. Rien de particulier n'est fait ici : on charge
 * le script public et on appelle les mêmes fonctions qu'un client, avec un jeton de site ordinaire.
 */
export class SedestralProactiveLuca {
    private static installed = false;

    static init(): void {
        if (config.isWhiteLabel) return;
        if (this.installed) return;

        const websiteToken = config.lucaWebsiteToken;
        if (!websiteToken) return;

        try {
            const w = window as any;
            // La file tampon accepte les appels déclenchés avant la fin du chargement du script.
            w.sedestral = w.sedestral || function () {
                w.sedestral.q = w.sedestral.q || [];
                w.sedestral.q.push(arguments);
            };

            const script = document.createElement('script');
            script.defer = true;
            // hors localhost, seuls les chemins sous /community/ sont relayés au microservice : le
            // script se charge donc par la même porte que tous les autres appels community
            script.src = `${config.httpCommunityUrl}/community/public/w/w.js`;
            script.setAttribute('data-website-id', websiteToken);
            script.setAttribute('data-domain', config.domainParent);
            document.head.appendChild(script);

            this.installed = true;
        } catch (err) {
            console.error(err);
        }
    }

    static identify(userId: string): void {
        this.call("identify", {user_id: userId});
    }

    static trackGoal(name: string, props?: Record<string, string>): void {
        this.call(name, props);
    }

    /**
     * La file tampon est posée ici et pas seulement à l'installation : une page peut déclarer un
     * objectif avant que le script ne soit chargé, et l'appel serait perdu sans bruit.
     */
    private static call(name: string, options?: Record<string, any>): void {
        try {
            const w = window as any;
            if (typeof w.sedestral !== "function") {
                w.sedestral = function () {
                    w.sedestral.q = w.sedestral.q || [];
                    w.sedestral.q.push(arguments);
                };
            }
            w.sedestral(name, options);
        } catch (err) {
            console.error(err);
        }
    }

    /**
     * Le suivi est-il réellement en place ? Sert à ne pas consommer un repère anti-doublon quand
     * l'envoi ne peut de toute façon pas partir.
     */
    static isInstalled(): boolean {
        return this.installed;
    }
}
